import { ValueOf } from 'types/util';

// shared
export enum SrpFilterName {
  Make = 'Make',
  Model = 'Model',
  Year = 'Year',
  Condition = 'Condition',
  Cylinders = 'Cylinders',
  Radius = 'Radius',
  SortBy = 'SortBy',
  Price = 'Price',
}

export type SrpFilterRangeValue = {
  min: number;
  max: number;
};

export type SrpConditionFilterValue = Partial<Record<SrpConditionName, boolean>>;

export type SrpConditionName = 'new' | 'used' | 'cpo' | 'includes_warranty';

// cylinders
export interface SrpCylindersFilterParams {
  name: SrpFilterName.Cylinders;
  value: SrpCylindersFilterValue;
}

export type SrpCylindersFilterValue = Partial<Record<SrpCylinderCount, boolean>>;

export type SrpCylinderCount = 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12;

// radius
export interface SrpRadiusFilterParams {
  name: SrpFilterName.Radius;
  value: SrpRadiusFilterValue;
}

export interface RadiusParams {
  number: number;
}

export type SrpRadiusFilterValue = RadiusParams;

// price
export interface SrpPriceFilterParams {
  name: SrpFilterName.Price;
  value: SrpPriceFilterValue;
}

export type SrpPriceFilterValue = Partial<{
  hideNoPriceListings: boolean;
}>;

// sort by
export interface SrpSortByFilterParams {
  name: SrpFilterName.SortBy;
  value: string;
}

//
// state
//
export interface SrpFiltersState {
  [SrpFilterName.Make]: string | undefined;
  [SrpFilterName.Model]: string | undefined;
  [SrpFilterName.Year]: SrpFilterRangeValue;
  [SrpFilterName.Condition]: SrpConditionFilterValue;
  [SrpFilterName.Cylinders]: SrpCylindersFilterValue;
  [SrpFilterName.Radius]: SrpRadiusFilterValue;
  [SrpFilterName.SortBy]: string | undefined;
  [SrpFilterName.Price]: SrpPriceFilterValue;
}

export type SrpFilterValue = ValueOf<SrpFiltersState>;
